import React from 'react';
import { cn } from './cn';

/** Skeleton — khối tải giả lập (pulse). */
export function Skeleton({ className, ...props }) {
  return <div className={cn('animate-pulse rounded-lg bg-gray-200 dark:bg-gray-800', className)} {...props} />;
}

/** Nhiều dòng skeleton. */
export function SkeletonText({ lines = 3, className }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={cn('h-4', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}

export default Skeleton;
